import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { ToolsSection } from '../components/dashboard/ToolsSection';
import { LegalServicesSection } from '../components/dashboard/LegalServicesSection';
import { NewUserDocumentHubSection } from '../components/dashboard/NewUserDocumentHubSection';
import { RequestCallModal } from '../components/modals/RequestCallModal';
export function NewUserDashboard() {
  const [showRequestCallModal, setShowRequestCallModal] = useState(false);
  // Mock data - in a real app this would come from the user's subscription/plan
  const userCategories = ['Business', 'HR'];
  const handleRequestCall = () => {
    setShowRequestCallModal(true);
  };
  return <div className="flex h-screen bg-slate-50" data-id="element-3896">
      <Sidebar data-id="element-3897" />
      <div className="flex-1 overflow-auto" data-id="element-3898">
        <DashboardHeader categories={userCategories} data-id="element-3899" />
        <main className="p-6" data-id="element-3900">
          <div className="grid grid-cols-1 gap-6 mb-6" data-id="element-3901">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3902">
              <h2 className="text-lg font-semibold mb-4" data-id="element-3903">Your Tools</h2>
              <ToolsSection data-id="element-3904" />
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3905">
              <h2 className="text-lg font-semibold mb-4" data-id="element-3906">Document Hub</h2>
              <NewUserDocumentHubSection data-id="element-3907" />
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3908">
              <h2 className="text-lg font-semibold mb-4" data-id="element-3909">Legal Services</h2>
              <LegalServicesSection onRequestCall={handleRequestCall} data-id="element-3910" />
            </div>
          </div>
        </main>
      </div>
      {showRequestCallModal && <RequestCallModal onClose={() => setShowRequestCallModal(false)} data-id="element-3911" />}
    </div>;
}